var _rect, _mask, _path, _path2, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.05563,
    y: 17.9062,
    width: 7.88889,
    height: 1.37037,
    rx: 0.5,
    fill: "#212121",
    stroke: "#212121"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_3293_2636",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.37109C16 4.81881 15.5523 4.37109 15 4.37109H1C0.447715 4.37109 0 4.81881 0 5.37109V6.48918C0 6.95579 0.378263 7.33406 0.844875 7.33406C1.28536 7.33406 1.65193 7.67248 1.68706 8.11156L2.42685 17.3589C2.46842 17.8786 2.9023 18.2792 3.42366 18.2792H12.5771C13.0985 18.2792 13.5324 17.8786 13.574 17.3589L14.3138 8.11117C14.3489 7.67231 14.7153 7.33406 15.1555 7.33406C15.6219 7.33406 16 6.95598 16 6.4896V5.37109Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5.37109C16 4.81881 15.5523 4.37109 15 4.37109H1C0.447715 4.37109 0 4.81881 0 5.37109V6.48918C0 6.95579 0.378263 7.33406 0.844875 7.33406C1.28536 7.33406 1.65193 7.67248 1.68706 8.11156L2.42685 17.3589C2.46842 17.8786 2.9023 18.2792 3.42366 18.2792H12.5771C13.0985 18.2792 13.5324 17.8786 13.574 17.3589L14.3138 8.11117C14.3489 7.67231 14.7153 7.33406 15.1555 7.33406C15.6219 7.33406 16 6.95598 16 6.4896V5.37109Z",
    fill: "#FCF8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3138 8.11117L15.3106 8.19091L14.3138 8.11117ZM13.574 17.3589L12.5771 17.2792L13.574 17.3589ZM2.42685 17.3589L1.43003 17.4386L2.42685 17.3589ZM1.68706 8.11156L0.690243 8.1913L1.68706 8.11156ZM1 5.37109H15V3.37109H1V5.37109ZM1 6.48918V5.37109H-1V6.48918H1ZM3.42366 17.2792L2.68387 8.03181L0.690243 8.1913L1.43003 17.4386L3.42366 17.2792ZM12.5771 17.2792H3.42366V19.2792H12.5771V17.2792ZM13.317 8.03142L12.5771 17.2792L14.5708 17.4386L15.3106 8.19091L13.317 8.03142ZM15 5.37109V6.4896H17V5.37109H15ZM15.1555 8.33406C16.1742 8.33406 17 7.50827 17 6.4896H15C15 6.4037 15.0696 6.33406 15.1555 6.33406V8.33406ZM15.3106 8.19091C15.3041 8.27175 15.2366 8.33406 15.1555 8.33406V6.33406C14.1939 6.33406 13.3937 7.07286 13.317 8.03142L15.3106 8.19091ZM12.5771 19.2792C13.6199 19.2792 14.4876 18.478 14.5708 17.4386L12.5771 17.2792V19.2792ZM1.43003 17.4386C1.51318 18.478 2.38094 19.2792 3.42366 19.2792V17.2792H3.42366L1.43003 17.4386ZM0.844875 8.33406C0.763997 8.33406 0.696693 8.27192 0.690243 8.1913L2.68387 8.03181C2.60717 7.07303 1.80672 6.33406 0.844875 6.33406V8.33406ZM-1 6.48918C-1 7.50808 -0.174022 8.33406 0.844875 8.33406V6.33406C0.930548 6.33406 1 6.40351 1 6.48918H-1ZM15 5.37109V5.37109H17C17 4.26652 16.1046 3.37109 15 3.37109V5.37109ZM1 3.37109C-0.104571 3.37109 -1 4.26653 -1 5.37109H1V5.37109V3.37109Z",
    fill: "#212121",
    mask: "url(#path-2-inside-1_3293_2636)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.5,
    width: 15,
    height: 1.96296,
    rx: 0.5,
    fill: "#3B1F8E",
    stroke: "#212121"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.83344,
    y: 0.722656,
    width: 4.33333,
    height: 1.37037,
    rx: 0.5,
    fill: "#212121",
    stroke: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJarIcon);
export default __webpack_public_path__ + "static/media/jarIcon.35e51635300124ea214c1caee9f8a679.svg";
export { ForwardRef as ReactComponent };